import React from 'react'

const Loading = () => {
    return (
        <div className="spinner-border text-white" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    )
}

export default Loading
